/* =========================================================================
   SWGEAR PromoBar rotator
   DESIGN_SYSTEM.md §4.21 + §12.3 #3
   - Rotates messages every N ms (section setting, default 4500)
   - Persists current index across page navigations via sessionStorage
   - Pauses on hover (if pause_on_hover === 'true')
   - Reduced-motion: shows only the first message, no rotation
   ========================================================================= */

(function () {
  'use strict';

  const STORAGE_KEY = 'swgearPromoIndex';

  function start(root) {
    const items = root.querySelectorAll('[data-promo-item]');
    if (items.length <= 1) return;

    const intervalMs = parseInt(root.dataset.rotationMs, 10) || 4500;
    const pauseOnHover = root.dataset.pauseOnHover === 'true';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    let index = 0;
    const stored = parseInt(sessionStorage.getItem(STORAGE_KEY) || '0', 10);
    if (!Number.isNaN(stored) && stored >= 0 && stored < items.length) {
      index = stored;
    }

    function show(i) {
      items.forEach((el, n) => {
        el.setAttribute('aria-hidden', n === i ? 'false' : 'true');
      });
      try {
        sessionStorage.setItem(STORAGE_KEY, String(i));
      } catch (_) {
        /* private mode etc — silent */
      }
    }

    show(index);

    if (reducedMotion) return;

    let timer = setInterval(advance, intervalMs);

    function advance() {
      index = (index + 1) % items.length;
      show(index);
    }

    if (pauseOnHover) {
      root.addEventListener('mouseenter', () => {
        clearInterval(timer);
        timer = null;
      });
      root.addEventListener('mouseleave', () => {
        if (!timer) timer = setInterval(advance, intervalMs);
      });
    }
  }

  function init() {
    document.querySelectorAll('.swgear-promo').forEach(start);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-init on theme-editor section reload */
  document.addEventListener('shopify:section:load', (e) => {
    const promo = e.target.querySelector('.swgear-promo');
    if (promo) start(promo);
  });
})();
